import React from 'react';

import * as styles from './bannerBlog.module.css';
import { AlmaLink } from '../alma-link';

export const BannerBlog = ({
  bannerCTA,
  bannerCopy,
  bannerText
}) => {

  return (
    <div className={styles.moduleContainer}>
      <div className={styles.contentContainer}>
        <div className={styles.bannerBlogContentContainer}>
          {bannerText && (
            <p className={styles.bannerBlogText}>{bannerText}</p>
          )}
          {bannerCopy && (
            <p className={styles.bannerBlogCopy}>{bannerCopy}</p>
          )}
        </div>
      </div>
      {bannerCTA?.title && (
        <AlmaLink
          cta={bannerCTA}
        />
      )}
    </div>
  );
};